import {useTranslation} from 'react-i18next';
import Header from './components/Header';
import AnnouncementsMain from './components/AnnouncementsMain';
import useScreenSize from '../../../../hooks/useScreenSize';

function AnnouncementsAndTasks() {
  const {i18n} = useTranslation();

  const screenSize = useScreenSize();
  const isLarge = screenSize == 'xl' || screenSize == '2xl';

  return (
    <div
      className={`w-full h-full flex flex-col ${
        isLarge
          ? i18n.language == 'heb'
            ? 'rounded-tl-[32px]'
            : 'rounded-tr-[32px]'
          : ''
      }`}>
      {/* Header */}
      <Header />

      <div className="flex-1 min-h-0">
        <AnnouncementsMain />
      </div>
    </div>
  );
}

export default AnnouncementsAndTasks;
